import React, { useState,useEffect, useRef } from 'react';
import {
    Input,
    Button,
    Layout,
    Row,Col,Modal,
    Tabs,Form,
    DatePicker,Radio,
    Select,
    Slider,
    Tooltip
} from 'antd';
import NextModel from '../Next_Model/Next_Model';
import { GetPropertyList,getUserList,fetchSoilProfileList,getSoilLayer,AddEditAnalysis } from '../../../../../util/Request';
import {
    WarningOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { useDispatch } from 'react-redux';
const { Content } = Layout;
const { Option } = Select;
import './add.less';


interface IProps {
    visible?:boolean;
    visibleCallback?:(param:boolean)=>void;
    editParam:any;
    defaultProfileid?:number
    defaultLayerId?:number
    addSuccessCallBack?: () => void
}
import {
    IUserManagementSearchModel,
} from '@/util/Request/requestType';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
import { SoilCloseIcon } from '@/resource/IconComponentSets';

const AddModel = (props:IProps) => {
    const { confirm } = Modal;
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [options,setOptions] = useState(<></> as React.ReactNode);
    const [AssociatedOptions,setAssociatedOptions] = useState(<></> as React.ReactNode);
    const [tabNum,setTabNum] = useState<string>('1');
    const [submitData,setSubmitData] = useState<any>({});
    const dispatch = useDispatch();

    const resetDefault = ()=>{
        form.resetFields();
        form2.resetFields();
        props.visibleCallback(false);
        setTabNum('1');
        setMinSlider(1);
        setMaxSlider(1);
        setSliderValue([1,1]);
        setLayerId('');
        setLayerOption(<></>);
    };


    const handleCancel = () => {
        confirm({
            title: 'Warning',
            style:{marginRight:100,top:300, borderRadius: '16px'},
            icon: <WarningOutlined style={{color:'#E99921'}}/>,
            content: 'Unsaved changes will be lost. Do you want to exit without saving?',
            okText: 'Exit without saving',
            okType: 'danger',
            className: 'modal-global-radius',
            cancelText: 'Stay on page',
            onOk() {
                resetDefault();
            },
            onCancel() {
                console.log('Cancel');
            },
        });
        // setSliderValue([10,40]);
    };
    const handleOk = async () => {
        if(tabNum=='2'){
            if(submitData.propertyMeasurements==undefined||submitData.propertyMeasurements.length==0){
                dispatch(updateWarningMessage('Soil Properties and Estimation Method is required !'));
                return;
            }
            if(submitData.propertyMeasurements.length>0){
                const ax = submitData.propertyMeasurements;
                let tr = true,td = true;
                ax.map(e=>{
                    if(e.propMeasureId==''){
                        tr = false;
                    }
                    if(e.propValue ==' '){
                        td = false;
                    }
                });
                if(!(tr&&td)){
                    let Lmessage = '';
                    (!tr)&&(Lmessage = 'Estimation Method is required !');
                    (!td)&&(Lmessage = 'Value is required !');
                    (!tr)&&(!td)&&(Lmessage = 'Estimation Method and Value is required !');
                    dispatch(updateWarningMessage(Lmessage));
                    return;
                }
            }
            const obj:any = {
                addEditFlag:'add'
            };
            if(props.editParam.requestedby!=null){
                obj.addEditFlag = 'edit';
                obj.sampleid = props.editParam.sampleid;
            }
            try {
                dispatch({type:'common/updateShowLoading',payload:true});
                const res = await AddEditAnalysis({...submitData,...obj});
                // console.log('lanxue add_edit res',res);
                if(res && (res?.message === 'True' || res?.message === 'true')){
                    dispatch(updateSuccessMessage(`${props.editParam?.sampleid!=''?'Soil Analysis has been changed':'New Soil Analysis added successfully'}`));
                    dispatch({
                        type: 'common/deleteFile'
                    });
                    resetDefault();
                    // SECTION: add success
                    props.addSuccessCallBack();
                }
                else{
                    dispatch(updateWarningMessage(res?.message));
                }
                dispatch({type:'common/updateShowLoading',payload:false});
            } catch (err) {
                dispatch({type:'common/updateShowLoading',payload:false});
            }
        }else{
            form.validateFields().then(values=>{
                console.log(values);
                console.log(sliderValue);
                const submitObj:any = {};
                Object.assign(submitObj,values,{sampleDepth:sliderValue[0]},{sampleEndDepth:sliderValue[1]},{sampleDate:`${moment(values.sampleDate).format('YYYY-MM-DD')}T00:00:00`});
                console.log(submitObj);
                setSubmitData({...submitData,...submitObj});
                form2.setFieldsValue({
                    profileid:submitObj.profileid,
                    layerid:submitObj.layerid
                });
                setTabNum('2');
            }).catch(err=>{
                console.log(err);
            });
        }
    };
    function callback(key, disable){
        if (key === '2' && disable) {
            setTabNum('2');
        }
        if (key === '1') {
            setTabNum('1');
        }
    }
    const [sliderValue,setSliderValue] = useState([1,1] as [number,number]);
    const [nextOption,setNextOption] = useState([] as any);
    const [visibleModel,setVisibleModel] = useState(false);
    const [tab2Disabled, setTab2Disabled] = useState(false);
    const getProperty = async ()=>{
        const response = await GetPropertyList();
        // console.log(response);
        setNextOption(response);
        // get all soil profile list
        const allProfileDataRequstData = {
            order: 'DESC',
            sortCol: 'code',
            pageIndex: 1,
            pageSize: 15
        };
        const res3 = await fetchSoilProfileList(allProfileDataRequstData);
        const option2 = res3?.map((obj)=> {
            return <Option value={obj.id} key={obj.id}>{obj.name}</Option>;
        });
        setAssociatedOptions(option2);
        const res2:IUserManagementSearchModel[] = await getUserList({isGetAllUsers: true});
        const option = res2.map((obj)=>{
            return <Option value={obj.userId} key={obj.userId}>{obj.userDisplayName}</Option>;
        });
        setOptions(option);
    };
    const initFunction = async ()=>{
        if(props.defaultProfileid!=null) {
            form.setFieldsValue({
                profileid:props.defaultProfileid
            });
            await handleChange(props.defaultProfileid);
        }
        if(props.defaultLayerId!=null) {
            form.setFieldsValue({
                layerid:props.defaultLayerId
            });
            setLayerId(props.defaultLayerId);
            setMaxsliderValue(props.defaultLayerId);
        }
        const {editParam,visible} = props;
        if(visible){
            // console.log(moment(editParam.sampleDate.split(' ')[0],'YYYY-MM-DD'));
            editParam.requestedby!=null&&setLayerId(editParam.layerid);
            editParam.requestedby!=null&&handleChange(editParam.profileid);
            editParam.requestedby!=null&&form.setFieldsValue({
                sampleDate:moment(editParam.sampleDate.split(' ')[0],'YYYY-MM-DD'),
                requestedby:editParam.requestedby,
                profileid:editParam.profileid,
                contributor:editParam.contributor,
                layerid:editParam.layerid,
                analysedby:editParam.analysedby,
                sampleStatusID:editParam.sampleStatusID,
                sampleExternalRef:editParam.sampleExternalRef
            });
            editParam.requestedby!=null&&setSliderValue([editParam.sampleDepth,editParam.sampleEndDepth]);
        }
        setVisibleModel(visible);
    };
    useEffect(() => {
        initFunction();
    }, [props.visible]);
    useEffect(() => {
        getProperty();
    }, []);
    const sliderChange = (value)=>{
        setSliderValue(value);
        return null;
    };
    let nex = 1;
    const submitTableData = (data)=>{
        console.log(data,nex);
        if(nex==1){
            nex++;
            console.log(data,nex);
            const arr = [];
            data.dataSource.length>0&&data.dataSource.map(obj=>{
                console.log(obj);
                arr.push({
                    propMeasureId:obj.methodID,
                    propValue:obj.age
                });
            });
            console.log(arr);
            // setPropertyMeasurements(arr);
            setSubmitData({...submitData,...{propertyMeasurements:arr}});
            setTimeout(e=>{
                nex=1;
            },200);
        }

    };
    const onFinish = async (values: any) => {
        console.log(values);
    };
    const [layerOption,setLayerOption] = useState(<></> as React.ReactNode);
    const [layerSelect,setLayerSelect] = useState([]);
    const handleChange = async (value) => {
        console.log(`selected ${value}`);
        if(value!=undefined&&value!=''){
            dispatch({type:'common/updateShowLoading',payload:true});
            form.setFieldsValue({
                layerid:''
            });
            const response = await getSoilLayer(value);
            setLayerSelect(response);
            const option = response.map((obj)=>{
                return <Option value={obj.layerId} key={obj.layerId}>{obj.layer}</Option>;
            });
            setLayerOption(option);
            dispatch({type:'common/updateShowLoading',payload:false});
        }
    };
    useEffect(()=>{
        setMaxsliderValue(layerId);
    },[layerSelect]);
    const [maxSlider,setMaxSlider] = useState(1);
    const [minSlider,setMinSlider] = useState(1);
    const [layerId,setLayerId] = useState<any>('');
    const setMaxsliderValue = (e)=>{
        console.log(e,layerSelect);
        if(layerSelect.length == 0) return;
        const ax = layerSelect.find(o=>o.layerId == e);
        console.log(ax);
        if(ax == undefined) return;
        setMinSlider(ax.layerStartDepth);
        setMaxSlider(ax.layerEndDepth);
        (layerId==''||props.defaultLayerId!=null)&&setSliderValue([ax.layerStartDepth,ax.layerEndDepth]);
        setLayerId('');
    };
    const [tooltipVisible,setTooltipVisible] = useState(false);
    const [tooltipText,setTooltipText] = useState('');
    const testIsRequired = ()=>{
        console.log(submitData);
        if(submitData.propertyMeasurements==undefined||submitData.propertyMeasurements.length==0){
            setTooltipText('Soil Properties and Estimation Method is required !');
            setTooltipVisible(true);
            return;
        }
        if(submitData.propertyMeasurements.length>0){
            const ax = submitData.propertyMeasurements;
            let tr = true;
            ax.map(e=>{
                if(e.propMeasureId==''){
                    tr = false;
                }
            });
            if(!tr){
                setTooltipText('Soil Properties and Estimation Method is required !');
                setTooltipVisible(true);
                return;
            }
        }
    };

    useEffect(() => {
        console.log('props.editParam?.requestedby?.length:====', props.editParam?.requestedby);
    }, [props.editParam]);

    const items = [
        {
            label: 'Analysis Definition',
            key: '1',
            children: (
                <Content key={1}>
                    <Form
                        name="basic"
                        layout="vertical"
                        onFinish={onFinish}
                        form={form}
                        autoComplete="off"
                        initialValues={{
                            sampleStatusID: 1,
                            sampleDate:moment()
                        }}
                    >
                        <Row gutter={[100,10]}>
                            <Col span={12}>
                                <Form.Item label="External Sample ID" name="sampleExternalRef">
                                    <Input size="large" placeholder='Input External Sample ID' disabled={
                                        props.editParam?.sampleid!=''&&(props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4)}>
                                    </Input>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Sampling Date" name="sampleDate">
                                    <DatePicker
                                        disabled={
                                            props.editParam?.sampleid!='' &&
                                             (props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4) ||
                                             props.editParam?.requestedby
                                        }
                                        style={{width:'100%'}} size="large"/>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Requested by" name="requestedby"
                                    rules={[{
                                        required: true,
                                        message: 'Requested by is required!'
                                    }]}>
                                    <Select
                                        placeholder="Select"
                                        size="large"
                                        showSearch
                                        disabled={props.editParam?.sampleid!=''&&(props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4)}
                                        filterOption={(input, option) => (option!.children?.toString()?.toLowerCase() as unknown as string).includes(input?.toLowerCase())}
                                    >
                                        {options}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="Associated Soil Profile" name="profileid"
                                    rules={[{
                                        required: true,
                                        message: 'Associated Soil Profile is required!'
                                    }]}>
                                    <Select
                                        placeholder="Select Soil Profile"
                                        disabled={props.editParam?.sampleid!=''&&(props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4)}
                                        onChange={handleChange}
                                        showSearch
                                        filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                        size="large">
                                        {AssociatedOptions}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Sample Taken by" name="contributor">
                                    <Select
                                        placeholder="Select"
                                        disabled={props.editParam?.sampleid!=''&&(props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4)}
                                        size="large"
                                        showSearch
                                        filterOption={(input, option) => (option!.children?.toString()?.toLowerCase() as unknown as string).includes(input?.toLowerCase())}
                                    >
                                        {options}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="Layer" name="layerid"
                                    rules={[{
                                        required: true,
                                        message: 'Layer is required!'
                                    }]}>
                                    <Select
                                        placeholder="Select Layer" size="large" onChange={setMaxsliderValue}
                                        disabled={props.editParam?.sampleid!=''&&(props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4)}>
                                        {layerOption}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Sample Analyzed by" name="analysedby">
                                    <Select
                                        placeholder="Select"
                                        size="large"
                                        showSearch
                                        disabled={props.editParam?.sampleid != '' && (props.editParam?.sampleStatusID == 2 || props.editParam?.sampleStatusID == 4)}
                                        filterOption={(input, option) => (option!.children?.toString()?.toLowerCase() as unknown as string).includes(input?.toLowerCase())}
                                    >
                                        {options}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Sampling Depth in cm" style={{display:'flex'}} name="sampleEndDepth">
                                    <Row gutter={10}>
                                        <Col span={4}>
                                            <Input size="large"
                                                style={{width:60,background:'#fff',textAlign:'center'}}
                                                readOnly
                                                value={sliderValue[0]}
                                            ></Input>
                                        </Col>
                                        <Col span={14} style={{ marginLeft: '15px', paddingLeft: '20px', overflow: 'visible' }}>
                                            <Slider
                                                disabled={props.editParam?.sampleid!=''&&(props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4)}
                                                range
                                                max={maxSlider}
                                                min={minSlider}
                                                value={sliderValue}
                                                onChange={sliderChange}
                                            />
                                        </Col>
                                        <Col span={4}>
                                            <Input size="large"
                                                style={{width:60, background:'#fff',textAlign:'center', marginLeft:'-8px'}}
                                                readOnly
                                                value={sliderValue[1]}
                                            ></Input>
                                        </Col>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Status" name="sampleStatusID"
                                    rules={[{ required: true, message: 'Status is required!' }]}>
                                    {/* <Checkbox >Activate</Checkbox> */}
                                    <Radio.Group size="large"
                                        disabled={props.editParam?.sampleStatusID==4}>
                                        <Radio.Button value={1} disabled={props.editParam?.sampleStatusID == 2}>Draft</Radio.Button>
                                        {/* <Radio.Button value={1} disabled={props.editParam?.sampleStatusID == 2 || props.editParam?.sampleStatusID == 3}>Draft</Radio.Button> */}
                                        <Radio.Button value={2}>Published</Radio.Button>
                                        {/* <Radio.Button value={3} disabled={props.editParam?.sampleStatusID == 2}>Finalised</Radio.Button> */}
                                        <Radio.Button value={4}>Obsolete</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Content>
            )},
        {
            label: (() => {
                let num = 0;
                if(props?.editParam?.sampleid!='') num = props.editParam?.samples?.propertyValues.length;
                return `Soil Properties (${num})`;
            })(),
            key: '2',
            disabled: tab2Disabled,
            children: (
                <>
                    <Form
                        name="basic"
                        layout="vertical"
                        onFinish={onFinish}
                        form={form2}
                    >
                        <Row gutter={20}>
                            <Col span={12}>
                                <Form.Item label="Associated Soil Profile" name="profileid">
                                    <Select
                                        dropdownMatchSelectWidth={false}
                                        placeholder="Select"
                                        disabled
                                        size='large'
                                    >
                                        {AssociatedOptions}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Layer" name="layerid">
                                    <Select
                                        dropdownMatchSelectWidth={false}
                                        placeholder="Select"
                                        disabled
                                        size="large"
                                    >
                                        {layerOption}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <NextModel
                        saveTable={submitTableData}
                        Table={undefined}
                        editOption={nextOption}
                        visible={props.visible}
                        editParam={props.editParam}
                        disabled={props.editParam?.sampleid!=''&&props.editParam?.sampleStatusID!=1}
                    />
                </>
            ) }
    ];

    return(
        <div className='analysis'>
            <Modal
                width='950px'
                className='analysis-modal-special-container'
                style={{ borderRadius: '16px !import' }}
                destroyOnClose={true}
                title={(() => {
                    return (
                        <div>
                            <span>{props.editParam?.sampleid!=''?'Edit':'Add'} Soil Analysis</span>
                        </div>
                    );
                })()}
                open={visibleModel}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
                closeIcon={<SoilCloseIcon />}
                footer={[
                    <Button key="cancel" type="default" size='large' shape="round" loading={confirmLoading} onClick={handleCancel}>
                        Cancel
                    </Button>,
                    (() => (tabNum == '1'?
                        <Button
                            key="submit-next"
                            type="primary"
                            size='large'
                            shape="round"
                            loading={confirmLoading}
                            onClick={handleOk}
                            disabled={
                                props.editParam?.sampleid!=''&&(props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4)&&tabNum!='1'
                            }
                        >
                            Next
                        </Button> :
                        <Tooltip open={tooltipVisible} placement="bottomRight" title={tooltipText}>
                            <Button
                                key="submit-save"
                                type="primary"
                                size='large'
                                shape="round"
                                loading={confirmLoading}
                                onClick={handleOk}
                                onMouseOver={testIsRequired}
                                onMouseLeave={e=>setTooltipVisible(false)}
                                disabled={
                                    props.editParam?.sampleid!=''&&(props.editParam?.sampleStatusID==2||props.editParam?.sampleStatusID==4)&&tabNum!='1'
                                }
                            >
                                Save
                            </Button>
                        </Tooltip>
                    ))()
                ]}
            >
                <Tabs activeKey={tabNum} onChange={(key) => callback(key, tab2Disabled)} items={items}/>
            </Modal>
        </div>
    );
};
export default AddModel;